import React from "react";
import { Link } from "react-router-dom";
import { Form, Button } from "react-bootstrap";

import courseLevelsService from "presentation/services/course-levels";
import evaluationSchemesService from "presentation/services/evaluation-schemes";
import academicPeriodsService from "presentation/services/academic-periods";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";
import CancelButton from "presentation/components/buttons/cancel";


import { handleChange } from "presentation/utils/functions/generic";

class CourseForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            localLoading: true,
            localError: false,
            message: '',
            courseLevels: [],
            academicPeriods: []
        }
    }

    async componentDidMount() {
        await this.loadData();
    }

    loadData = async () => {

        let academicPeriods = [];
        let courseLevels = [];
        let evaluationSchemes = [];
        let localError = false;
        let errorMessages = [];
        let message = '';

        this.setState({ ...this.state, localLoading: true, localError: false, message: '' });

        try {

            const [courseLevelsResult, evaluationSchemesResult, academicPeriodsResults] = await Promise.all([
                courseLevelsService.findAll(),
                evaluationSchemesService.findAll(),
                academicPeriodsService.findAll()
            ]);


            if (courseLevelsResult.error === true) {
                localError = true;
                errorMessages.push("Não foi possível recuperar a listagem de níveis/segmentos...");
            } else if (courseLevelsResult.length <= 0) {
                localError = true;
                errorMessages.push("Por favor, cadastre níveis/segmentos antes de cadastrar um curso...");
            } else {
                courseLevels = courseLevelsResult;
            }

            if (academicPeriodsResults.error === true) {
                localError = true;
                errorMessages.push("Não foi possível recuperar os períodos acadêmicos...");
            } else if (academicPeriodsResults.length <= 0) {
                localError = true;
                errorMessages.push("Por favor, cadastre períodos acadêmicos, antes de cadastrar um curso...");
            } else {
                academicPeriods = academicPeriodsResults;
            }

            //Falta de regimes de avaliação não trava o cadastro

            if (evaluationSchemesResult.error !== true && evaluationSchemesResult.length > 0) {
                evaluationSchemes = evaluationSchemesResult;
            }

            if (localError === true) {
                message = errorMessages.join(" / ");
                this.setState({
                    ...this.state,
                    localError: true,
                    localLoading: false,
                    message: message
                });
            } else {
                this.setState({
                    ...this.state,
                    courseLevels: courseLevels,
                    academicPeriods: academicPeriods,
                    evaluationSchemes: evaluationSchemes,
                    localError: false,
                    localLoading: false,
                    message: ''
                });
            }

        } catch (err) {
            this.setState({
                localLoading: false,
                localError: true,
                message: "Erro inesperado ao carregar dados: " + err.message
            });
        }


    }

    render() {
        var { localLoading, localError, message, courseLevels, academicPeriods, evaluationSchemes } = this.state;
        var { loading, form, handleSubmit, component } = this.props;

        return (
            <>
                {loading === true || localLoading === true && <PageLoadingIndicator loadingText={"Carregando informações..."} />}
                {(localLoading === false && localError === true) && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
                {
                    loading === false && localLoading === false && (

                        <Form>
                            <h4>Informações do curso</h4>
                            <div className="form mt-2">
                                <Form.Label htmlFor="academicPeriodId">Período Acadêmico</Form.Label>
                                <Form.Select
                                    aria-label="Período Acadêmico"
                                    defaultValue={form.academicPeriodId}
                                    id="academicPeriodId"
                                    name="academicPeriodId"
                                    onChange={(e) => handleChange(e, component)}
                                    aria-describedby="academicPeriodIdHelpBlock"
                                    required
                                >
                                    <option>Selecione um período acadêmico</option>
                                    {academicPeriods.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                                </Form.Select>
                                <Form.Text id="academicPeriodIdHelpBlock" muted>
                                    Defina qual o período acadêmico do curso
                                </Form.Text>
                            </div>
                            <div className="form mt-2">
                                <Form.Label htmlFor="courseLevelId">Nível/segmento do curso</Form.Label>
                                <Form.Select
                                    aria-label="Nível/segmento"
                                    defaultValue={form.courseLevelId}
                                    id="courseLevelId"
                                    name="courseLevelId"
                                    onChange={(e) => handleChange(e, component)}
                                    aria-describedby="courseLevelIdHelpBlock"
                                    required
                                >
                                    <option>Selecione um nível/segmento</option>
                                    {courseLevels.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                                </Form.Select>
                                <Form.Text id="courseLevelIdHelpBlock" muted>
                                    Defina a qual nível segmento esse curso pertence
                                </Form.Text>
                            </div>
                            <div className="form mt-2">
                                <Form.Label htmlFor="evaluationSchemeId">Regime de avaliação</Form.Label>
                                <Form.Select
                                    aria-label="Regime de avaliação"
                                    defaultValue={form.evaluationSchemeId}
                                    id="evaluationSchemeId"
                                    name="evaluationSchemeId"
                                    onChange={(e) => handleChange(e, component)}
                                    aria-describedby="evaluationSchemeIdHelpBlock"
                                >
                                    <option>Escolha um regime de avaliação</option>
                                    {evaluationSchemes.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                                </Form.Select>
                                <Form.Text id="academicPeriodIdHelpBlock" muted>
                                    Se esse curso precisar, escolha qual será o regime de avaliação dele
                                </Form.Text>
                            </div>
                            <div className="form">
                                <Form.Label htmlFor="name">Curso</Form.Label>
                                <Form.Control
                                    type="text"
                                    id="name"
                                    name="name"
                                    defaultValue={form.name}
                                    onChange={(e) => handleChange(e, component)}
                                    aria-describedby="nameHelpBlock"
                                />
                                <Form.Text id="nameHelpBlock" muted>
                                    Informe nome do curso
                                </Form.Text>
                            </div>
                            <div className="form mt-2">
                                <Form.Label htmlFor="displayName">Nome de exibição do curso</Form.Label>
                                <Form.Control
                                    type="text"
                                    id="displayName"
                                    name="displayName"
                                    defaultValue={form.displayName}
                                    onChange={(e) => handleChange(e, component)}
                                    aria-describedby="displayNameHelpBlock"
                                />
                                <Form.Text id="displayNameHelpBlock" muted>
                                    Escolha um nome de exibição
                                </Form.Text>
                            </div>
                            <div className="form mt-2">
                                <Form.Label htmlFor="displayName">Código do curso</Form.Label>
                                <Form.Control
                                    type="text"
                                    id="code"
                                    name="code"
                                    defaultValue={form.code}
                                    onChange={(e) => handleChange(e, component)}
                                    aria-describedby="codeHelpBlock"
                                />
                                <Form.Text id="codeHelpBlock" muted>
                                    Escolha um código
                                </Form.Text>
                            </div>
                            <div className="mt-3">
                                <CancelButton
                                    containerProps={{
                                        as: Link,
                                        to: `/cursos`
                                    }}
                                />
                                <Button disabled={loading || localError} variant="success" className="float-end" onClick={() => handleSubmit()}>Salvar</Button>
                            </div>
                        </Form>
                    )
                }
            </>
        );
    };
}

export default CourseForm;